/**
 * Format a byte count for compact UI display ("1.4 KB", "812 B", "3.2 MB").
 *
 * Uses binary (1024-based) thresholds because runtime payload sizes are
 * measured against the raw blob in storage, but renders compact SI-style
 * labels ("KB/MB/GB/TB") to match how the rest of the portal surfaces sizes.
 * Returns `undefined` so callers can render nothing when there's no number
 * to show — guarded against negative inputs.
 */
export function formatBytes(bytes: number | null | undefined): string | undefined {
  if (bytes === null || bytes === undefined || !Number.isFinite(bytes) || bytes < 0) {
    return undefined;
  }
  if (bytes < 1024) return `${bytes} B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let value = bytes / 1024;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  // Show one decimal for values < 10 ("1.4 KB"), no decimal beyond ("128 KB").
  const formatted = value >= 10 ? Math.round(value).toString() : value.toFixed(1);
  return `${formatted} ${units[unit]}`;
}
